import styled from 'styled-components';
import { colors } from 'assets/styled/tokens/colors';
import { medias } from 'assets/styled/tokens';

export const MobileContainer = styled.div`
  display: flex;
  align-items: center;
  @media (min-width: ${medias.tablet}) {
    display: none;
  }
`;

export const UserCircle = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: #f28c28;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.white};

  svg {
    fill: #f28c28;
  }
`;

export const StyledMobileMenu = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${colors.white};
  z-index: 100;
  padding: 16px;
  transform: ${props => (props.isOpen ? 'translateX(0)' : 'translateX(100%)')};
  transition: transform 0.3s ease-in-out;
`;

export const MobileMenuHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;

  .help-button {
    display: flex;
    align-items: center;
    gap: 8px;
    background: none;
    border: 1px solid ${colors.lightGray};
    border-radius: 20px;
    padding: 6px 12px;
    font-size: 13px;
    color: ${colors.gray};
    text-decoration: none;

    svg {
      color: #f28c28;
    }
  }
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  color: ${colors.gray};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
`;

export const MobileUserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;

  .user-name {
    font-weight: bold;
    color: ${colors.gray};
  }

  .user-email {
    font-size: 14px;
    color: ${colors.gray};
    opacity: 0.8;
  }
`;

export const MobileUserIcon = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: #f28c28;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.white};
`;

export const MobileMenuItems = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const MobileMenuItem = styled.a`
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 16px;
  cursor: pointer;
  border-radius: 8px;
  transition: all 0.15s ease;
  color: ${colors.gray};
  text-decoration: none;

  &:hover {
    background-color: ${colors.lightGray};
  }

  svg {
    color: #f28c28;
  }
`;

export const MobileFooter = styled.div`
  position: absolute;
  bottom: 24px;
  left: 16px;
  right: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${colors.gray};

  .social-icons {
    display: flex;
    gap: 12px;
  }
`;

export const SocialIcon = styled.a`
  color: ${colors.gray};
  transition: all 0.2s ease;

  &:hover {
    color: #f28c28;
    transform: translateY(-2px);
  }
`;
